<ion-card>
    <ion-card-content (click)="display = !display">
        <ion-label *ngIf="!display">Show Customer Details...</ion-label>
        <ion-label *ngIf="display">Hide Customer Details...</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="display && document.customer">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <b>Name</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.customer.name }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add1</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.customer.add1 }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add2</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.customer.add2 }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add3</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.customer.add3 }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add4</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.customer.add4 }}</b>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>

<ion-card *ngIf="(display && document.site)">
    <ion-card-content (click)="display = !display">
        <ion-label *ngIf="!display">Show Site Details...</ion-label>
        <ion-label *ngIf="display">Site Details...</ion-label>
        
    </ion-card-content>
    <ion-card-content>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <b>Name</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.site.name }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add1</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.site.add1 }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add2</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.site.add2 }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add3</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.site.add3 }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Add4</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.site.add4 }}</b>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>

<ion-card *ngIf="display && document.contact">
    <ion-card-content (click)="display = !display">
        <ion-label *ngIf="!display">Show Contact Details...</ion-label>
        <ion-label *ngIf="display">Contact Details...</ion-label>
    </ion-card-content>
    <ion-card-content>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <b>Name</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.contact.name }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Phone</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.contact.phone }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Email</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.contact.email }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Fax</b>
                </ion-col>
                <ion-col>
                    <b>{{ document.contact.fax }}</b>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>
